module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view chat-view bg-white clearfix"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "chat-inner",
    attrs: {
      "id": "my-conversation"
    }
  }, _vm._l((_vm.messages), function(message) {
    return _c('div', {
      staticClass: "message clearfix"
    }, [_vm._m(1, true, false), _vm._v(" "), (message.user_id === _vm.user.id) ? _c('div', {
      staticClass: "chat-bubble from-me"
    }, [_vm._v(_vm._s(message.content))]) : _vm._e(), _vm._v(" "), (message.user_id !== _vm.user.id) ? _c('div', {
      staticClass: "chat-bubble from-them"
    }, [_vm._v(_vm._s(message.content))]) : _vm._e()])
  })), _vm._v(" "), _vm._m(2, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('a', {
    staticClass: "link text-master inline action p-l-10 p-r-10",
    attrs: {
      "href": "javascript:;",
      "data-navigate": "view",
      "data-view-port": "#chat",
      "data-view-animation": "push-parrallax"
    }
  }, [_c('i', {
    staticClass: "pg-arrow_left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "view-heading"
  }, [_vm._v("\n        John Smith\n        "), _c('div', {
    staticClass: "fs-11 hint-text"
  }, [_vm._v("Online")])]), _vm._v(" "), _c('a', {
    staticClass: "link text-master inline action p-r-10 pull-right ",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "pg-more"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-img-wrapper m-t-5 inline"
  }, [_c('img', {
    staticClass: "col-top",
    attrs: {
      "width": "30",
      "height": "30",
      "src": require("../assets/img/profiles/avatar_small.jpg"),
      "alt": "",
      "data-src": "../assets/img/profiles/avatar_small.jpg",
      "data-src-retina": "../assets/img/profiles/avatar_small2x.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "b-t b-grey bg-white clearfix p-l-10 p-r-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-1 p-t-15"
  }, [_c('a', {
    staticClass: "link text-master",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 no-padding"
  }, [_c('input', {
    staticClass: "form-control chat-input",
    attrs: {
      "type": "text",
      "data-chat-input": "",
      "data-chat-conversation": "#my-conversation",
      "placeholder": "Say something"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 link text-master m-l-10 m-t-15 p-l-10 b-l b-grey col-top"
  }, [_c('a', {
    staticClass: "link text-master",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "pg-camera"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d652474"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/conversation.vue
// module id = 1359
// module chunks = 1